import type { DocMigration } from "../docMigration";

const ZERO_EPSILON = 1e-10;

function getLumberProfileId(thickness: number): string {
  if (Math.abs(thickness - 11.25) <= ZERO_EPSILON) {
    return "defaultStructuralMaterial2X12";
  } else if (Math.abs(thickness - 9.25) <= ZERO_EPSILON) {
    return "defaultStructuralMaterial2X10";
  } else if (Math.abs(thickness - 7.25) <= ZERO_EPSILON) {
    return "defaultStructuralMaterial2X8";
  } else if (Math.abs(thickness - 5.5) <= ZERO_EPSILON) {
    return "defaultStructuralMaterial2X6";
  } else if (Math.abs(thickness - 3.5) <= ZERO_EPSILON) {
    return "defaultStructuralMaterial2X4";
  } else {
    return "structuralMaterialNotFound";
  }
}

function getPlywoodProfile(thickness: number): string {
  if (Math.abs(thickness - 0.5) <= ZERO_EPSILON) {
    return "defaultPlywoodMaterialU1Over2SR16";
  } else if (Math.abs(thickness - 0.75) <= ZERO_EPSILON) {
    return "defaultPlywoodMaterialU3Over4SR16";
  } else if (Math.abs(thickness - 0.59375) <= ZERO_EPSILON) {
    return "defaultPlywoodMaterialU19Over32SR16";
  } else if (Math.abs(thickness - 0.625) <= ZERO_EPSILON) {
    return "defaultPlywoodMaterialU5Over8SR16";
  } else {
    return "defaultPlywoodMaterialU3Over4SR16";
  }
}
// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_203: DocMigration = {
  maxSchemaVersion: "0.0.203",
  description: "Migrate plate thickness in floorComponents to actual dimensional lumber for both joists and panels",

  apply(json: any) {
    const { settings } = json;

    for (const id in settings) {
      const setting = settings[id];
      if (setting.type === "FLOOR_CATALOG_SETTINGS") {
        for (const componentId in setting.floorComponents) {
          const component = setting.floorComponents[componentId];
          if (component.componentType === "STRUCTURE") {
            const lumberProfileId = getLumberProfileId(component.thickness);
            setting.floorComponents[componentId] = {
              ...component,
              joistType: lumberProfileId === "structuralMaterialNotFound" ? "CUSTOM_JOISTS" : "WOOD_JOISTS",
              joistSpacing: 16,
              spanDirection: "SHORTEST_SPAN",
              joistProfileId: lumberProfileId,
            };
          } else if (component.componentType === "SUBFLOOR") {
            setting.floorComponents[componentId] = {
              ...component,
              substrateProfileType: "PLYWOOD",
              spanRating: "SR16",
              substrateProfileId: getPlywoodProfile(component.thickness),
            };
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_203;
